module.exports = __webpack_public_path__ + "315e754c424cfd7871792076da707123.MP3";